export function ArcGauge({ value, size = 72, stroke = 7, color = "#6366f1" }) {
  const pct = Math.min(100, Math.max(0, Number(value) || 0));
  const r = (size - stroke) / 2;
  const circ = 2 * Math.PI * r;
  const offset = circ - (pct / 100) * circ;
  return (
    <svg
      width={size}
      height={size}
      style={{ transform: "rotate(-90deg)", display: "block" }}
    >
      <circle
        cx={size / 2}
        cy={size / 2}
        r={r}
        fill="none"
        stroke="rgba(99,102,241,0.12)"
        strokeWidth={stroke}
      />
      <circle
        cx={size / 2}
        cy={size / 2}
        r={r}
        fill="none"
        stroke={color}
        strokeWidth={stroke}
        strokeDasharray={circ}
        strokeDashoffset={offset}
        strokeLinecap="round"
        style={{
          transition: "stroke-dashoffset 0.9s cubic-bezier(0.4,0,0.2,1)",
        }}
      />
    </svg>
  );
}

/** Arc gauge with percentage centered inside the ring (table / compact views). */
export function ScoreRing({
  value,
  size = 44,
  stroke = 4,
  color = "#6366f1",
  showLabel = true,
  label,
}) {
  const pct = Math.min(100, Math.max(0, Math.round(Number(value) || 0)));
  const displayLabel = label ?? `${pct}%`;
  const labelSize = size <= 36 ? 8 : size <= 44 ? 9 : size <= 52 ? 10 : 12;

  return (
    <div
      style={{
        position: "relative",
        width: size,
        height: size,
        flexShrink: 0,
      }}
    >
      <ArcGauge value={pct} size={size} stroke={stroke} color={color} />
      {showLabel && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            pointerEvents: "none",
          }}
        >
          <span
            style={{
              fontSize: labelSize,
              fontWeight: 800,
              color,
              lineHeight: 1,
            }}
          >
            {displayLabel}
          </span>
        </div>
      )}
    </div>
  );
}
